import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import UpdateCourier from './UpdateCourier';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, couriers, newCourier, error, message, selectedCourier,
  } = state.courier;
  return {
    isLoading,
    couriers,
    newCourier,
    error,
    message,
    selectedCourier,
  };
}

const Styled = withStyles(styles)(UpdateCourier);

export default connect(
  mapStateToProps,
)(Styled);
